import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { SegmentedControl } from '@ui/components/SegmentedControl/SegmentedControl'

import { useWindowResize } from '@utils/domUtils'

import { IntroducingBrokerReferralTypes } from '@model/IntroducingBrokerDetailsDto'

import { Box } from '@shared/components/Box'

interface LinkHubSectionHeaderProps {
  title: string
  activeTab: IntroducingBrokerReferralTypes
  setActiveTab: (id: IntroducingBrokerReferralTypes) => void
  shouldRenderSegmentedControl?: boolean
  layout?: 'column' | 'row'
  isSegmentedControlWidthConstrained?: boolean
}

export const SectionHeader = ({
  title,
  activeTab,
  setActiveTab,
  shouldRenderSegmentedControl,
  layout = 'column',
  isSegmentedControlWidthConstrained,
}: LinkHubSectionHeaderProps) => {
  const { t } = useTranslation()
  const isMobile = useWindowResize()

  const boxProps =
    layout === 'row'
      ? {
          direction: 'row' as const,
          justify: 'space-between' as const,
          align: 'center' as const,
        }
      : {
          direction: 'column' as const,
          gap: 'x4' as const,
        }

  return (
    <Box flex {...boxProps}>
      <Body2 semibold>{title}</Body2>
      {shouldRenderSegmentedControl ? (
        <Box
          flexItem='1'
          maxWidth={!isMobile && isSegmentedControlWidthConstrained ? 160 : undefined}
        >
          <SegmentedControl
            size='md'
            activeTab={activeTab}
            tabs={[
              {
                id: IntroducingBrokerReferralTypes.Default,
                name: t('IB.LinkHubPage.IB'),
                onClick: () => setActiveTab(IntroducingBrokerReferralTypes.Default),
              },
              {
                id: IntroducingBrokerReferralTypes.MultiTier,
                name: t('IB.LinkHubPage.Multi-Tier IB'),
                onClick: () => setActiveTab(IntroducingBrokerReferralTypes.MultiTier),
              },
            ]}
          />
        </Box>
      ) : null}
    </Box>
  )
}
